import { InjectionToken } from '@angular/core';
import { DateOptions } from './models/date-options.model';

export const DEFAULT_DATE_OPTIONS: DateOptions = {
  // Date pipe format
  LongDateFormat: 'M/d/yy h:mma',
  ShortDateFormat: 'MMM D, YYYY',
  // Date Format for NgbDatepicker which uses moment date format
  NgbDateFormat: 'MMM DD, YYYY',
};

/**
 * This is a token for the date options used in the date pipe and the date picker
 * The default value is US date format where month comes before day
 * Changing the values can be done in the app.module.ts
 * @example
 * change the date format to UK date format where day comes before month
 * in app.module.ts add the following code in the providers array
 *
 * providers: [
 *  {
 *    provide: DATE_OPTIONS,
 *    useValue: {
 *      LongDateFormat: 'd/M/yy h:mma',
 *      ShortDateFormat: 'dd MMM, YYYY',
 *      NgbDateFormat: 'DD MM, YYYY'
 *    }
 *  }
 * ]
 */
export const DATE_OPTIONS = new InjectionToken<DateOptions>('dateOption', {
  providedIn: 'root',
  factory: () => {
    // Defaults to US date format where month comes before day
    return DEFAULT_DATE_OPTIONS;
  },
});
